// Keep the reading and keyboard order identical to the visible mobile order.
// Every section remains controlled by its existing published Ghost page.
export default function mobileHomepage() {
    const wayfinding = document.querySelector('.lds-ghost-wayfinding');
    const stories = document.querySelector('.lds-ghost-home-story-pillar--stories');
    const comingUp = document.querySelector('.lds-ghost-coming-up');
    if (!wayfinding) return;
    document.body.classList.add('lds-mobile-home-wayfinding');
    if (!stories) return;
    const anchor = document.createComment('Your Stories desktop position');
    stories.before(anchor);
    const media = window.matchMedia('(max-width: 600px)');
    const update = () => {
        if (media.matches) (comingUp || wayfinding).after(stories);
        else anchor.after(stories);
    };
    media.addEventListener('change', update);
    update();
}
